export type BwIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
};

const withBwIconProps =
  (Component: React.ComponentType<React.SVGProps<SVGSVGElement>>) =>
  ({ size = 16, width, height, ...restProps }: BwIconProps) => {
    return (
      <Component
        width={width || height ? width : size}
        height={width || height ? height : size}
        {...restProps}
      />
    );
  };

export default withBwIconProps;
